
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M1.5 6.75h6.63m-6.63 3.5h3.791m7.85-4.683v-1.24c0-.456-.317-.827-.706-.827H2.205c-.39 0-.705.37-.705.828v8.344c0 .457.316.828.705.828h4.428M5.508 3.528v9.938M9.575 3.528v2.04"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","d":"m13.579 10.185-2.365 2.365-1.092-1.091m5.458-.364a3.639 3.639 0 1 1-7.277 0 3.639 3.639 0 0 1 7.277 0"}})])
          )
        }
      }
    